import React from 'react'

import { ContactSearchResult } from '../../../../../../../types/responses/global-search'
import SearchResultHeading from '../SearchResultHeading'
import ContactSearchResultItem from './components/ContactSearchResultItem'

interface Props {
  searchResults: ContactSearchResult[]
}

const ReferralSearchResults: React.FC<Props> = ({ searchResults }) => {
  if (searchResults.length === 0) {
    return null
  }

  return (
    <div className="d-flex flex-column gap-2">
      <SearchResultHeading
        label="Contacts"
        resultCount={searchResults.length}
      />

      {searchResults.map((referral) => (
        <ContactSearchResultItem key={referral.id} contact={referral} />
      ))}
    </div>
  )
}

export default ReferralSearchResults
